import { type CanvasBlock } from "./types";

export function getBlockKey(block: CanvasBlock, idx: number): string {
  if (block.type === "section") return `section-${block.id}`;
  if (block.type === "heading")
    return `h${block.level}-${block.text.slice(0, 20)}-${idx}`;
  if (block.type === "metric") return `metric-${block.label}-${idx}`;
  if (block.type === "card") return `card-${block.title.slice(0, 15)}-${idx}`;
  return `block-${idx}`;
}

export function collectSectionIds(blocks: CanvasBlock[]): string[] {
  const ids: string[] = [];
  const visit = (block: CanvasBlock): void => {
    if (block.type === "section") {
      ids.push(block.id);
      block.children.forEach(visit);
      return;
    }
    if (
      block.type === "card" ||
      block.type === "grid" ||
      block.type === "expandable"
    ) {
      block.children.forEach(visit);
      return;
    }
    if (block.type === "list") {
      block.items.forEach(visit);
    }
  };
  blocks.forEach(visit);
  return ids;
}
